<template>
		<div class="template-login-register">
			<header class="header-animation step2">
				<div class="top">
					<div class="container">
						<a href="https://simoniot.com">
							<img src="../../assets/img/logo-dark.png" alt="">
						</a>

						<router-link to='/login'>Login</router-link>
					</div>
				</div>
			</header>
				<div class="contentpage">
					<div class="container-register">
						<div :class="['step2', classTypeAccount]">
							<div class="reg-head">
								<h3>Registration</h3>
								<h4>{{classTypeAccount}} Account</h4>
							</div>

							<div class="innerbox">
								<div class="formRegister">
									<fieldset :class="['company-field', vErrors && vErrors.has('company-name') ? 'error-field' : '']">
										<label for="company-name">Company Name</label>
										<input type="text" class="form-control" name="company-name" v-model="newuser.companyName" v-validate="'required'" data-vv-as="company name">
										<span v-show="vErrors && vErrors.has('company-name')" class="validate-warning">{{ vErrors.first('company-name') }}</span>
									</fieldset>

									<fieldset :class="[vErrors && vErrors.has('fname-user') ? 'error-field' : '']">
										<label for="fname-user">First Name</label>
										<input type="text" class="form-control" name="fname-user" v-model="newuser.firstName" v-validate="'required|alpha'" data-vv-as="first name">
										<span v-show="vErrors && vErrors.has('fname-user')" class="validate-warning">{{ vErrors.first('fname-user') }}</span>
									</fieldset>

									<fieldset :class="[vErrors && vErrors.has('lname-user') ? 'error-field' : '']">
										<label for="lname-user">Last Name</label>
										<input type="text" class="form-control" name="lname-user" v-model="newuser.lastName" v-validate="'required|alpha'" data-vv-as="last name">
										<span v-show="vErrors && vErrors.has('lname-user')" class="validate-warning">{{ vErrors.first('lname-user') }}</span>
									</fieldset>

									<fieldset :class="[vErrors && vErrors.has('email-user') ? 'error-field' : '']">
										<label for="email-user">Email</label>
										<input type="email" class="form-control" name="email-user" v-model="newuser.email" v-validate="'required|email'" data-vv-as="email address">
										<span v-show="vErrors && vErrors.has('email-user')" class="validate-warning">{{ vErrors.first('email-user') }}</span>
									</fieldset>

									<fieldset :class="[vErrors && vErrors.has('password1') ? 'error-field' : '']">
										<label for="password1">Password</label>
										<input type="password" class="form-control" name="password1" id="password1" ref="password1" v-validate='{required: true, regex: regexPassword}' data-vv-as="password">
										<span v-show="vErrors && vErrors.has('password1')" class="validate-warning">Password must contain: at least minimum 8 signs, one uppercase character, one lowercase character, one special character and one number.</span>
									</fieldset>

									<fieldset :class="[vErrors && vErrors.has('password2') ? 'error-field' : '']">
										<label for="password2r">Retype password</label>
										<input type="password" class="form-control" name="password2" id="password2" v-model="newuser.password" v-validate="{required: true, confirmed: 'password1', regex: regexPassword}" data-vv-as="password">
										<span v-show="vErrors && vErrors.has('password2')" class="validate-warning">{{ vErrors.first('password2') }}</span>
									</fieldset>

									<fieldset v-if="classTypeAccount == 'Business'" :class="['company-field', vErrors && vErrors.has('taxid-user') ? 'error-field' : '']">
										<label for="taxid">TAX ID</label>
										<input type="text" class="form-control" name="taxid-user" v-model="newuser.taxId" v-validate="{regex: /(^[0-9]+-?[0-9]+$)|(^[0-9]+$)/}" data-vv-as="TAX ID">
										<span v-show="vErrors && vErrors.has('taxid-user')" class="validate-warning">{{ vErrors.first('taxid-user') }}</span>
									</fieldset>

									<fieldset :class="[errorPhoneNumber ||  errorPhoneNumberTaken ? 'error-field' : '']">
										<label for="pnumber-user">Phone Number</label>
										<vue-tel-input class="form-control" v-bind="bindProps" :validCharactersOnly="true" v-model="newuser.phoneNumber.number" name="errorPhoneNumber"></vue-tel-input>
										<span v-if="errorPhoneNumberTaken" class="validate-warning">Phone number taken</span>
										<span v-if="errorPhoneNumber" class="validate-warning">Please type phone number in right format</span>
									</fieldset>

									<div class="auto-fill-address">
										<input ref="locationInput" type="text" placeholder="Start typing address" v-model="location" @focusin="showHints()" @focusout="hideHints()" @input="unlockHints()" autocomplete="false" class="form-control auto-fill-input">
										<div v-if="searchResults.length > 0 && hintSelected == false && displayHints" class="auto-fill-hints-list">
											<div v-for="(result, i) in searchResults" :key="i" class="auto-fill-hint" @click="getSelectedLocation(result)">
												{{ result.description }}
											</div>
										</div>
										<div v-if="hintSelectedError != ''" class="auto-fill-error">{{hintSelectedError}}</div>
										<div class="w-30 address-card">
											<fieldset :class="[vErrors && vErrors.has('addr1') ? 'error-field' : '']">
												<label for="addr1">Address line 1</label>
												<input name="addr1" id="addr1" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.addressLine1" v-validate="'required'" class="form-control"/>
												<span v-show="vErrors && vErrors.has('addr1')" class="validate-warning">{{ vErrors.first('addr1') }}</span>
											</fieldset>
											<fieldset>
												<label>Address line 2</label>
												<input name="addr2" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.addressLine2" class="form-control"/>
											</fieldset>
											<fieldset :class="[vErrors && vErrors.has('city') ? 'error-field' : '']">
												<label for="city">City</label>
												<input name="city" id="city" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.city" v-validate="'required'" class="form-control"/>
												<span v-show="vErrors && vErrors.has('city')" class="validate-warning">{{ vErrors.first('city') }}</span>
											</fieldset>
											<fieldset v-if="newuser.country == 'United States'">
												<label>State / Region</label>
												<select name="state" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.state" class="form-control">
													<option v-for="state in stateList" :key="state.abbreviation" :value="state.abbreviation">{{state.name}}</option>
												</select>
											</fieldset>
											<fieldset v-else>
												<label>State / Region</label>
												<input name="state" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.state" class="form-control"/>
											</fieldset>
											<fieldset v-if="newuser.country == 'United States'" :class="[vErrors && vErrors.has('pcode-user') ? 'error-field' : '']">
												<label>Zip</label>
												<input name="pcode-user" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.postalCode" v-validate="{required: true, regex: /^[0-9]{5}(-[0-9]{4})?$/}" data-vv-as="postal code" class="form-control"/>
												<span v-show="vErrors && vErrors.has('pcode-user')" class="validate-warning">{{ vErrors.first('pcode-user') }}</span>
											</fieldset>
											<fieldset v-if="newuser.country == 'Canada'" :class="[vErrors && vErrors.has('pcode-user') ? 'error-field' : '']">
												<label>Zip</label>
												<input name="pcode-user" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.postalCode" v-validate="{required: true, regex: /^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}$/}" data-vv-as="postal code" class="form-control"/>
												<span v-show="vErrors && vErrors.has('pcode-user')" class="validate-warning">{{ vErrors.first('pcode-user') }}</span>
											</fieldset>
											<fieldset v-if="newuser.country != 'United States' && newuser.country != 'Canada'" :class="[vErrors && vErrors.has('pcode-user') ? 'error-field' : '']">
												<label>Zip</label>
												<input name="pcode-user" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.postalCode" v-validate="{required: true}" data-vv-as="postal code" class="form-control"/>
												<span v-show="vErrors && vErrors.has('pcode-user')" class="validate-warning">{{ vErrors.first('pcode-user') }}</span>
											</fieldset>
											<fieldset>
												<label>Country</label>
												<select name="country" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newuser.country" class="form-control">
													<option v-for="country in countriesList" :value="country.name" :key="country.code">{{country.name}}</option>
												</select>
											</fieldset>
										</div>
									</div>

									<fieldset>
										<label for="referralCode">Referal Code</label>
										<input type="text" class="form-control" id="referralCode" v-model="newuser.referralCode"/>
									</fieldset>

									<fieldset :class="[vErrors && vErrors.has('time-zone') ? 'error-field' : '']">
										<label for="time-zone">Timezone</label>
										<select class="form-control" name="time-zone" id="time-zone" v-model="newuser.displayTimeZoneId" v-validate="'required'" data-vv-as="timezone">
											<option v-for="zone in timeZones" v-bind:key="zone.id" :value="zone.id">{{zone.tzdbId.replace(/_/g, ' ')}}</option>
										</select>
										<span v-show="vErrors && vErrors.has('time-zone')" class="validate-warning">{{ vErrors.first('time-zone') }}</span>
									</fieldset>

									<fieldset :class="['terms-and-conditions', vErrors && vErrors.has('terms-conditions') ? 'error-field' : '']">
										<div class="terms-and-conditions-box">
											<input @click="showTermsModal" type="checkbox" name="terms-conditions" id="terms-conditions" v-model="termsConditionsAccepted" v-validate="'required'" data-vv-as="terms and conditions"/>
											<label @click="showTermsModal" for="terms-conditions">
												<span v-if="termsConditionsAccepted">I Accept the <span class="colored">Terms and Conditions</span></span>
												<span v-else>Please read and accept the <span class="colored">Terms and conditions</span></span>
											</label>
										</div>
										<span v-show="vErrors && vErrors.has('terms-conditions')" class="validate-warning">{{ vErrors.first('terms-conditions') }}</span>
									</fieldset>

									<fieldset :class="['recaptcha', (captchaError || captchaError2) ? 'error-field' : '']">
										<vue-recaptcha ref="recaptcha" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod" sitekey="6LcqsQ8hAAAAACTgTWzvhWrGtGI61m3x3PLwq-9U" />
										<span v-if="captchaError" class="validate-warning">Please fill the Captcha</span>
										<span v-if="captchaError2" class="validate-warning">Captcha is missing or invalid</span>
									</fieldset>

									<fieldset class="button-wrap">
										<button class="btn-back" v-on:click.prevent="goBack">Back</button>

										<button class="btn btn-success" v-on:click.prevent="submitRegisterForm" type="submit">Create Account</button>
									</fieldset>
								</div>
							</div>
						</div>
					</div>
				</div>

				<footer>

				</footer>
			<b-modal hide-footer hide-header id="accept-terms" ref="accept-terms" size="lg" class="accept-terms" centered title="Terms and conditions">
				<div class="terms-and-conditions-topbar">
					<h3>Terms and conditions</h3>
					<i class="fa fa-close" @click="hideTermsModal()"></i>
				</div>
				<div class="terms-and-conditions-text" v-html="termsContent" @scroll="checkScroll"></div>
				<div :class="['accept-bar', termsRead ? 'buttons-visible' : 'text-visible']">
					<button class="btn btn-light" @click="hideTermsModal()">Cancel</button>
					<button class="btn btn-success accept" @click="acceptTerms()" :disabled="!termsRead">Accept Terms and Conditions</button>
					<p>Scroll down to accept terms and conditions</p>
				</div>
			</b-modal>
		</div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import VueMeta from 'vue-meta'
import VueSession from "vue-session";
import globalStore from "../../variables";
import VueParticles from 'vue-particles'
import vueCountryRegionSelect from "vue-country-region-select";
import VeeValidate from 'vee-validate';
import { VueTelInput } from 'vue-tel-input'
import awesomePhonenumber from 'awesome-phonenumber'
import VueCookies from 'vue-cookies'
import { VueRecaptcha } from 'vue-recaptcha'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(VueParticles)
Vue.use(VueSession);
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

const veeValidateConfig = {
	errorBagName: 'vErrors'
};

Vue.use(VeeValidate, veeValidateConfig);

export default {
	name: "Register",
	data() {
		return {
			addr2: '',
			location: '',
			searchResults: [],
			displayHints: false,
			service: null,
			field2: '',
			street: '',
			city: '',
			state: '',
			zip: '',
			country: '',
			regexPassword: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\ \!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@\[\\\]\^\_\`\{\|\}\~]).{8,}$/,
			errorPhoneNumber: false,
			errorPhoneNumberTaken: false,
			classTypeAccount: '',
			newuser: {
				companyName: '',
				firstName: '',
				lastName: '',
				email: '',
				taxId: '',
				phoneNumber: {
					dialCode: '',
					number: ''
				},
				addressLine1: '',
				addressLine2: '',
				city: '',
				postalCode: '',
				country: '',
				state: '',
				password: '',
				displayTimeZoneId: '',
				referralCode: ''
			},
			termsConditionsAccepted: false,
			stateList: [
				{
					"name": "Alabama",
					"abbreviation": "AL"
				},
				{
					"name": "Alaska",
					"abbreviation": "AK"
				},
				{
					"name": "American Samoa",
					"abbreviation": "AS"
				},
				{
					"name": "Arizona",
					"abbreviation": "AZ"
				},
				{
					"name": "Arkansas",
					"abbreviation": "AR"
				},
				{
					"name": "California",
					"abbreviation": "CA"
				},
				{
					"name": "Colorado",
					"abbreviation": "CO"
				},
				{
					"name": "Connecticut",
					"abbreviation": "CT"
				},
				{
					"name": "Delaware",
					"abbreviation": "DE"
				},
				{
					"name": "District Of Columbia",
					"abbreviation": "DC"
				},
				{
					"name": "Federated States Of Micronesia",
					"abbreviation": "FM"
				},
				{
					"name": "Florida",
					"abbreviation": "FL"
				},
				{
					"name": "Georgia",
					"abbreviation": "GA"
				},
				{
					"name": "Guam",
					"abbreviation": "GU"
				},
				{
					"name": "Hawaii",
					"abbreviation": "HI"
				},
				{
					"name": "Idaho",
					"abbreviation": "ID"
				},
				{
					"name": "Illinois",
					"abbreviation": "IL"
				},
				{
					"name": "Indiana",
					"abbreviation": "IN"
				},
				{
					"name": "Iowa",
					"abbreviation": "IA"
				},
				{
					"name": "Kansas",
					"abbreviation": "KS"
				},
				{
					"name": "Kentucky",
					"abbreviation": "KY"
				},
				{
					"name": "Louisiana",
					"abbreviation": "LA"
				},
				{
					"name": "Maine",
					"abbreviation": "ME"
				},
				{
					"name": "Marshall Islands",
					"abbreviation": "MH"
				},
				{
					"name": "Maryland",
					"abbreviation": "MD"
				},
				{
					"name": "Massachusetts",
					"abbreviation": "MA"
				},
				{
					"name": "Michigan",
					"abbreviation": "MI"
				},
				{
					"name": "Minnesota",
					"abbreviation": "MN"
				},
				{
					"name": "Mississippi",
					"abbreviation": "MS"
				},
				{
					"name": "Missouri",
					"abbreviation": "MO"
				},
				{
					"name": "Montana",
					"abbreviation": "MT"
				},
				{
					"name": "Nebraska",
					"abbreviation": "NE"
				},
				{
					"name": "Nevada",
					"abbreviation": "NV"
				},
				{
					"name": "New Hampshire",
					"abbreviation": "NH"
				},
				{
					"name": "New Jersey",
					"abbreviation": "NJ"
				},
				{
					"name": "New Mexico",
					"abbreviation": "NM"
				},
				{
					"name": "New York",
					"abbreviation": "NY"
				},
				{
					"name": "North Carolina",
					"abbreviation": "NC"
				},
				{
					"name": "North Dakota",
					"abbreviation": "ND"
				},
				{
					"name": "Northern Mariana Islands",
					"abbreviation": "MP"
				},
				{
					"name": "Ohio",
					"abbreviation": "OH"
				},
				{
					"name": "Oklahoma",
					"abbreviation": "OK"
				},
				{
					"name": "Oregon",
					"abbreviation": "OR"
				},
				{
					"name": "Palau",
					"abbreviation": "PW"
				},
				{
					"name": "Pennsylvania",
					"abbreviation": "PA"
				},
				{
					"name": "Puerto Rico",
					"abbreviation": "PR"
				},
				{
					"name": "Rhode Island",
					"abbreviation": "RI"
				},
				{
					"name": "South Carolina",
					"abbreviation": "SC"
				},
				{
					"name": "South Dakota",
					"abbreviation": "SD"
				},
				{
					"name": "Tennessee",
					"abbreviation": "TN"
				},
				{
					"name": "Texas",
					"abbreviation": "TX"
				},
				{
					"name": "Utah",
					"abbreviation": "UT"
				},
				{
					"name": "Vermont",
					"abbreviation": "VT"
				},
				{
					"name": "Virgin Islands",
					"abbreviation": "VI"
				},
				{
					"name": "Virginia",
					"abbreviation": "VA"
				},
				{
					"name": "Washington",
					"abbreviation": "WA"
				},
				{
					"name": "West Virginia",
					"abbreviation": "WV"
				},
				{
					"name": "Wisconsin",
					"abbreviation": "WI"
				},
				{
					"name": "Wyoming",
					"abbreviation": "WY"
				}
			],
			countriesList: [
				{"name": "Afghanistan", "code": "AF"},
				{"name": "Åland Islands", "code": "AX"},
				{"name": "Albania", "code": "AL"},
				{"name": "Algeria", "code": "DZ"},
				{"name": "American Samoa", "code": "AS"},
				{"name": "AndorrA", "code": "AD"},
				{"name": "Angola", "code": "AO"},
				{"name": "Anguilla", "code": "AI"},
				{"name": "Antarctica", "code": "AQ"},
				{"name": "Antigua and Barbuda", "code": "AG"},
				{"name": "Argentina", "code": "AR"},
				{"name": "Armenia", "code": "AM"},
				{"name": "Aruba", "code": "AW"},
				{"name": "Australia", "code": "AU"},
				{"name": "Austria", "code": "AT"},
				{"name": "Azerbaijan", "code": "AZ"},
				{"name": "Bahamas", "code": "BS"},
				{"name": "Bahrain", "code": "BH"},
				{"name": "Bangladesh", "code": "BD"},
				{"name": "Barbados", "code": "BB"},
				{"name": "Belarus", "code": "BY"},
				{"name": "Belgium", "code": "BE"},
				{"name": "Belize", "code": "BZ"},
				{"name": "Benin", "code": "BJ"},
				{"name": "Bermuda", "code": "BM"},
				{"name": "Bhutan", "code": "BT"},
				{"name": "Bolivia", "code": "BO"},
				{"name": "Bosnia and Herzegovina", "code": "BA"},
				{"name": "Botswana", "code": "BW"},
				{"name": "Bouvet Island", "code": "BV"},
				{"name": "Brazil", "code": "BR"},
				{"name": "British Indian Ocean Territory", "code": "IO"},
				{"name": "Brunei Darussalam", "code": "BN"},
				{"name": "Bulgaria", "code": "BG"},
				{"name": "Burkina Faso", "code": "BF"},
				{"name": "Burundi", "code": "BI"},
				{"name": "Cambodia", "code": "KH"},
				{"name": "Cameroon", "code": "CM"},
				{"name": "Canada", "code": "CA"},
				{"name": "Cape Verde", "code": "CV"},
				{"name": "Cayman Islands", "code": "KY"},
				{"name": "Central African Republic", "code": "CF"},
				{"name": "Chad", "code": "TD"},
				{"name": "Chile", "code": "CL"},
				{"name": "China", "code": "CN"},
				{"name": "Christmas Island", "code": "CX"},
				{"name": "Cocos (Keeling) Islands", "code": "CC"},
				{"name": "Colombia", "code": "CO"},
				{"name": "Comoros", "code": "KM"},
				{"name": "Republic of the Congo", "code": "CG"},
				{"name": "Democratic Republic of the Congo", "code": "CD"},
				{"name": "Cook Islands", "code": "CK"},
				{"name": "Costa Rica", "code": "CR"},
				{"name": "Cote D\"Ivoire", "code": "CI"},
				{"name": "Croatia", "code": "HR"},
				{"name": "Cuba", "code": "CU"},
				{"name": "Cyprus", "code": "CY"},
				{"name": "Czechia", "code": "CZ"},
				{"name": "Denmark", "code": "DK"},
				{"name": "Djibouti", "code": "DJ"},
				{"name": "Dominica", "code": "DM"},
				{"name": "Dominican Republic", "code": "DO"},
				{"name": "Ecuador", "code": "EC"},
				{"name": "Egypt", "code": "EG"},
				{"name": "El Salvador", "code": "SV"},
				{"name": "Equatorial Guinea", "code": "GQ"},
				{"name": "Eritrea", "code": "ER"},
				{"name": "Estonia", "code": "EE"},
				{"name": "Ethiopia", "code": "ET"},
				{"name": "Islas Malvinas", "code": "FK"},
				{"name": "Faroe Islands", "code": "FO"},
				{"name": "Fiji", "code": "FJ"},
				{"name": "Finland", "code": "FI"},
				{"name": "France", "code": "FR"},
				{"name": "French Guiana", "code": "GF"},
				{"name": "French Polynesia", "code": "PF"},
				{"name": "French Southern Territories", "code": "TF"},
				{"name": "Gabon", "code": "GA"},
				{"name": "Gambia", "code": "GM"},
				{"name": "Georgia", "code": "GE"},
				{"name": "Germany", "code": "DE"},
				{"name": "Ghana", "code": "GH"},
				{"name": "Gibraltar", "code": "GI"},
				{"name": "Greece", "code": "GR"},
				{"name": "Greenland", "code": "GL"},
				{"name": "Grenada", "code": "GD"},
				{"name": "Guadeloupe", "code": "GP"},
				{"name": "Guam", "code": "GU"},
				{"name": "Guatemala", "code": "GT"},
				{"name": "Guernsey", "code": "GG"},
				{"name": "Guinea", "code": "GN"},
				{"name": "Guinea-Bissau", "code": "GW"},
				{"name": "Guyana", "code": "GY"},
				{"name": "Haiti", "code": "HT"},
				{"name": "Heard Island and McDonald Islands", "code": "HM"},
				{"name": "Vatican City", "code": "VA"},
				{"name": "Honduras", "code": "HN"},
				{"name": "Hong Kong", "code": "HK"},
				{"name": "Hungary", "code": "HU"},
				{"name": "Iceland", "code": "IS"},
				{"name": "India", "code": "IN"},
				{"name": "Indonesia", "code": "ID"},
				{"name": "Iran, Islamic Republic Of", "code": "IR"},
				{"name": "Iraq", "code": "IQ"},
				{"name": "Ireland", "code": "IE"},
				{"name": "Isle of Man", "code": "IM"},
				{"name": "Israel", "code": "IL"},
				{"name": "Italy", "code": "IT"},
				{"name": "Jamaica", "code": "JM"},
				{"name": "Japan", "code": "JP"},
				{"name": "Jersey", "code": "JE"},
				{"name": "Jordan", "code": "JO"},
				{"name": "Kazakhstan", "code": "KZ"},
				{"name": "Kenya", "code": "KE"},
				{"name": "Kiribati", "code": "KI"},
				{"name": "North Korea", "code": "KP"},
				{"name": "South Korea", "code": "KR"},
				{"name": "Kuwait", "code": "KW"},
				{"name": "Kyrgyzstan", "code": "KG"},
				{"name": "Laos", "code": "LA"},
				{"name": "Latvia", "code": "LV"},
				{"name": "Lebanon", "code": "LB"},
				{"name": "Lesotho", "code": "LS"},
				{"name": "Liberia", "code": "LR"},
				{"name": "Libyan Arab Jamahiriya", "code": "LY"},
				{"name": "Liechtenstein", "code": "LI"},
				{"name": "Lithuania", "code": "LT"},
				{"name": "Luxembourg", "code": "LU"},
				{"name": "Macao", "code": "MO"},
				{"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
				{"name": "Madagascar", "code": "MG"},
				{"name": "Malawi", "code": "MW"},
				{"name": "Malaysia", "code": "MY"},
				{"name": "Maldives", "code": "MV"},
				{"name": "Mali", "code": "ML"},
				{"name": "Malta", "code": "MT"},
				{"name": "Marshall Islands", "code": "MH"},
				{"name": "Martinique", "code": "MQ"},
				{"name": "Mauritania", "code": "MR"},
				{"name": "Mauritius", "code": "MU"},
				{"name": "Mayotte", "code": "YT"},
				{"name": "Mexico", "code": "MX"},
				{"name": "Federated States of Micronesia", "code": "FM"},
				{"name": "Moldova, Republic of", "code": "MD"},
				{"name": "Monaco", "code": "MC"},
				{"name": "Mongolia", "code": "MN"},
				{"name": "Montserrat", "code": "MS"},
				{"name": "Morocco", "code": "MA"},
				{"name": "Mozambique", "code": "MZ"},
				{"name": "Myanmar", "code": "MM"},
				{"name": "Namibia", "code": "NA"},
				{"name": "Nauru", "code": "NR"},
				{"name": "Nepal", "code": "NP"},
				{"name": "Netherlands", "code": "NL"},
				{"name": "Netherlands Antilles", "code": "AN"},
				{"name": "New Caledonia", "code": "NC"},
				{"name": "New Zealand", "code": "NZ"},
				{"name": "Nicaragua", "code": "NI"},
				{"name": "Niger", "code": "NE"},
				{"name": "Nigeria", "code": "NG"},
				{"name": "Niue", "code": "NU"},
				{"name": "Norfolk Island", "code": "NF"},
				{"name": "Northern Mariana Islands", "code": "MP"},
				{"name": "Norway", "code": "NO"},
				{"name": "Oman", "code": "OM"},
				{"name": "Pakistan", "code": "PK"},
				{"name": "Palau", "code": "PW"},
				{"name": "Palestinian Territory, Occupied", "code": "PS"},
				{"name": "Panama", "code": "PA"},
				{"name": "Papua New Guinea", "code": "PG"},
				{"name": "Paraguay", "code": "PY"},
				{"name": "Peru", "code": "PE"},
				{"name": "Philippines", "code": "PH"},
				{"name": "Pitcairn", "code": "PN"},
				{"name": "Poland", "code": "PL"},
				{"name": "Portugal", "code": "PT"},
				{"name": "Puerto Rico", "code": "PR"},
				{"name": "Qatar", "code": "QA"},
				{"name": "Reunion", "code": "RE"},
				{"name": "Romania", "code": "RO"},
				{"name": "Russian Federation", "code": "RU"},
				{"name": "RWANDA", "code": "RW"},
				{"name": "Saint Helena", "code": "SH"},
				{"name": "Saint Kitts and Nevis", "code": "KN"},
				{"name": "Saint Lucia", "code": "LC"},
				{"name": "Saint Pierre and Miquelon", "code": "PM"},
				{"name": "Saint Vincent and the Grenadines", "code": "VC"},
				{"name": "Samoa", "code": "WS"},
				{"name": "San Marino", "code": "SM"},
				{"name": "Sao Tome and Principe", "code": "ST"},
				{"name": "Saudi Arabia", "code": "SA"},
				{"name": "Senegal", "code": "SN"},
				{"name": "Serbia and Montenegro", "code": "CS"},
				{"name": "Seychelles", "code": "SC"},
				{"name": "Sierra Leone", "code": "SL"},
				{"name": "Singapore", "code": "SG"},
				{"name": "Slovakia", "code": "SK"},
				{"name": "Slovenia", "code": "SI"},
				{"name": "Solomon Islands", "code": "SB"},
				{"name": "Somalia", "code": "SO"},
				{"name": "South Africa", "code": "ZA"},
				{"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
				{"name": "Spain", "code": "ES"},
				{"name": "Sri Lanka", "code": "LK"},
				{"name": "Sudan", "code": "SD"},
				{"name": "Suriname", "code": "SR"},
				{"name": "Svalbard and Jan Mayen", "code": "SJ"},
				{"name": "Swaziland", "code": "SZ"},
				{"name": "Sweden", "code": "SE"},
				{"name": "Switzerland", "code": "CH"},
				{"name": "Syrian Arab Republic", "code": "SY"},
				{"name": "Taiwan", "code": "TW"},
				{"name": "Tajikistan", "code": "TJ"},
				{"name": "Tanzania", "code": "TZ"},
				{"name": "Thailand", "code": "TH"},
				{"name": "Timor-Leste", "code": "TL"},
				{"name": "Togo", "code": "TG"},
				{"name": "Tokelau", "code": "TK"},
				{"name": "Tonga", "code": "TO"},
				{"name": "Trinidad and Tobago", "code": "TT"},
				{"name": "Tunisia", "code": "TN"},
				{"name": "Turkey", "code": "TR"},
				{"name": "Turkmenistan", "code": "TM"},
				{"name": "Turks and Caicos Islands", "code": "TC"},
				{"name": "Tuvalu", "code": "TV"},
				{"name": "Uganda", "code": "UG"},
				{"name": "Ukraine", "code": "UA"},
				{"name": "United Arab Emirates", "code": "AE"},
				{"name": "United Kingdom", "code": "GB"},
				{"name": "United States", "code": "US"},
				{"name": "United States Minor Outlying Islands", "code": "UM"},
				{"name": "Uruguay", "code": "UY"},
				{"name": "Uzbekistan", "code": "UZ"},
				{"name": "Vanuatu", "code": "VU"},
				{"name": "Venezuela", "code": "VE"},
				{"name": "Viet Nam", "code": "VN"},
				{"name": "British Virgin Islands", "code": "VG"},
				{"name": "USVI", "code": "VI"},
				{"name": "Wallis and Futuna", "code": "WF"},
				{"name": "Western Sahara", "code": "EH"},
				{"name": "Yemen", "code": "YE"},
				{"name": "Zambia", "code": "ZM"},
				{"name": "Zimbabwe", "code": "ZW"}
			],
			bindProps: {
				defaultCountry: "USA",
				disabledFetchingCountry: false,
				disabled: false,
				disabledFormatting: false,
				placeholder: "Enter a phone number",
				required: true,
				enabledCountryCode: true,
				enabledFlags: true,
				preferredCountries: ["USA"],
				onlyCountries: [],
				ignoredCountries: [],
				autocomplete: "off",
				name: "telephone",
				maxLen: 25,
				wrapperClasses: "",
				inputClasses: "",
				dropdownOptions: {
					disabledDialCode: false
				},
				inputOptions: {
					showDialCode: false
				}
			},
			timeZones: '',
			termsRead: false,
			clientIp: '',
			termsContent: '',
			hintSelected: false,
			hintSelectedError: '',
			captchaToken: '',
			captchaError: false,
			captchaError2: false
		};
	},
	metaInfo () {
		return {
			script: [{
				src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBvAuWDKz9dAP1Td4ZXSfdcrbeN9cX_glg&region=US&language=en-US&libraries=places',
				async: true,
				defer: true,
				callback:() => this.mapsInit()
			}]
		}
	},
	components: {
		VueTelInput,
		awesomePhonenumber,
		VueRecaptcha
	},
	watch: {
		location (newValue) {
			if (newValue) {
				this.service.getPlacePredictions({
					input: this.location
				}, this.displaySuggestions)
			}
		}
	},
	methods: {
		errorMethod(response) {
			this.captchaError2 = true;
		}, 
		renderMethod(response) {
			this.captchaToken = '';
		},
		verifyMethod(response) {
			this.captchaToken = response;
			this.captchaError2 = false;
			this.captchaError = false;
		},
		expiredMethod(response) {
			this.captchaToken = '';
			this.captchaError2 = true;
		},
		getSelectedLocation(location) {
			this.geoServices.geocode({
				placeId: location.place_id
			}, (result, status) => {
				this.location = location.description
				this.hintSelected = true
				this.parseSelectedOption(result[0])
			})
		},
		showHints() {
			this.displayHints = true
		},
		hideHints() {
			setTimeout(() => {
				this.displayHints = false
			},100)
		},
		parseSelectedOption(data) {
			this.newuser.addressLine1 = ''
			this.newuser.addressLine2 = ''
			this.newuser.city = ''
			this.newuser.state = ''
			this.newuser.postalCode = ''
			this.newuser.country = ''
			let address = data.formatted_address
			let streetParsed = address.substr(0, address.indexOf(','))
			this.newuser.addressLine1 = streetParsed
			let addressObject = data.address_components
			for (let part of addressObject) {
				if (part.types[0] == "postal_town") {
					this.newuser.city = part.long_name
				} else if (part.types[0] == "locality" && part.types[1] == "political") {
					this.newuser.city = part.long_name
				} else if (part.types[0] == "administrative_area_level_1" && part.types[1] == "political") {
					this.newuser.state = part.short_name
				} else if (part.types[0] == "country" && part.types[1] == "political") {
					this.newuser.country = part.long_name
				} else if (part.types[0] == "postal_code") {
					this.newuser.postalCode = part.long_name
				}
			}
		},
		unlockHints() {
			this.hintSelected = false
		},
		getGeocoderRequest(placeId) {
			this.geoServices('GeocoderRequest', {
				placeId: placeId
			}, this.geocoderResponse)
		},
		geocoderResponse(response, status) {
			console.log(response, status);
		},
		mapsInit() {
			this.service = new window.google.maps.places.AutocompleteService();
			this.geoServices = new window.google.maps.Geocoder();
		},
		displaySuggestions (predictions, status) {
			if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
				this.searchResults = [];
				return
			}
			this.searchResults = predictions.map(prediction => prediction);
		},
		getTimezones() {
			Axios.get(`${globalStore.data.restApiUrl}/time-zones`)
				.then(response => {
					this.timeZones = response.data
				}).catch(error => {
					this.$notify({
						type: 'warn',
						group: 'notification',
						title: 'Get Timezones list',
						text: 'Something was wrong with get timezones list.',
						duration: 5000,
					});
					return false;
				})
		},
		showNameCoutry() {
			console.log(this.newuser.country)
		},
		goBack() {
			this.$router.push({name: 'RegisterStep1'});
		},
		clearFormInputs() {
			this.newuser.firstName = '';
			this.newuser.lastName = '';
			this.newuser.email = '';
			this.newuser.taxId = '';
			this.newuser.phoneNumber = '';
			this.newuser.addressLine1 = '';
			this.newuser.addressLine2 = '';
			this.newuser.city = '';
			this.newuser.postalCode = '';
			this.newuser.country = '';
			this.newuser.state = '';
			this.newuser.displayTimeZoneId = '';
			this.newuser.password = '';

			return true;
		},
		submitRegisterForm(ev) {
			this.hintSelectedError = ''

			let countryCode = document.querySelector(".vue-tel-input .vti__country-code").innerHTML

			countryCode = '+' + parseFloat(countryCode);

			if (this.newuser.phoneNumber.number) {
				let contryCode = document.querySelector("div.vti__flag").classList[1]
				let phoneNumberObj = new awesomePhonenumber(this.newuser.phoneNumber.number, contryCode);

				if (!phoneNumberObj.isValid()) {
					this.errorPhoneNumber = true;
					this.$notify({
						type: 'error',
						group: 'notification',
						title: 'Registration problem',
						text: 'Phone number field is missing',
						duration: 5000,
					});
					return false;
				} else {
					this.errorPhoneNumber = false;
				}

				this.newuser.phoneNumber.dialCode = countryCode
			} else {
				this.errorPhoneNumber = true;
				this.$notify({
					type: 'error',
					group: 'notification',
					title: 'Registration problem',
					text: 'Phone number field is missing',
					duration: 5000,
				});
				return false;
			}

			if (this.captchaToken == '' || this.captchaError == true) {
				this.captchaError = true;
				return false;
			} else {
				this.captchaError = false;
			}

			if (this.captchaError2 == true) {
				return false;
			}

			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.hintSelected == false) {
						this.hintSelectedError = 'Please, select address'
						this.$notify({
							type: 'error',
							group: 'notification',
							title: 'Registration problem',
							text: 'Please, select address from hint and fill it correctly. If there is no your location, please select closest one and correct it.',
							duration: 5000,
						});
						return false
					}
					window.newUserEmail = this.newuser.email;

					let newCompany = {};

					newCompany.companyName = this.newuser.companyName;
					newCompany.firstName = this.newuser.firstName;
					newCompany.lastName = this.newuser.lastName;
					newCompany.email = this.newuser.email;
					newCompany.password = this.newuser.password;
					newCompany.addressLine1 = this.newuser.addressLine1;
					newCompany.city = this.newuser.city;
					newCompany.postalCode = this.newuser.postalCode;
					newCompany.country = this.newuser.country;
					newCompany.displayTimeZoneId = this.newuser.displayTimeZoneId;
					newCompany.phoneNumber = {};
					newCompany.phoneNumber.dialCode = this.newuser.phoneNumber.dialCode;
					newCompany.phoneNumber.number = this.newuser.phoneNumber.number;

					if (this.newuser.addressLine2 != '') {
						newCompany.addressLine2 = this.newuser.addressLine2;
					}

					if (this.classTypeAccount == 'Business' && this.newuser.taxId != '') {
						newCompany.taxId = this.newuser.taxId;
					}

					if (this.newuser.country == 'United States') {
						newCompany.state = this.newuser.state;
					}

					if (this.newuser.referralCode != null && this.newuser.referralCode != '') {
						newCompany.referralCode = this.newuser.referralCode
					}

					Axios.put(globalStore.data.restApiUrl + '/register/user?captchaToken=' + this.captchaToken, newCompany, {headers: {clientIp: this.clientIp}})
						.then(response => {
							if (response.status == '200' || response.status == '201') {
								this.$router.push('/register/summary')
							}
						}).catch(error => {
							let errorCode = error.response.data.errors;
							window.newUserEmail = '';

							this.errorPhoneNumberTaken = false;
							this.errorPhoneNumber = false;

							for (let err in errorCode) {

								console.log(errorCode[err]['errorMessage'])

								if (errorCode[err]['errorCode'] == 'CaptchaExeption') {
									this.$notify({
										type: 'error',
										group: 'notification',
										title: 'Registration problem',
										text: errorCode[err]['details'],
										duration: 5000,
									});
									this.captchaError2 = true;
								}

								if (errorCode[err]['errorMessage'] == 'Phone number taken') {
									this.$notify({
										type: 'error',
										group: 'notification',
										title: 'Registration problem',
										text: 'Phone number already in use. Provide another or reach support.',
										duration: 5000,
									});
									this.errorPhoneNumberTaken = true;
								}

								if (errorCode[err]['errorMessage'] == 'E-mail already registered') {
									this.$notify({
										type: 'error',
										group: 'notification',
										title: 'Registration problem',
										text: 'Email already in use. Provide another or reach support.',
										duration: 5000,
									});
									this.vErrors.add({
										field: 'email-user',
										msg: 'Email already in use. Provide another or reach support.'
									})
								}

								if (errorCode[err]['errorMessage'] == 'Selected company name is already taken') {
									this.vErrors.add({
										field: 'company-name',
										msg: 'Selected company name is already taken'
									})
									this.$notify({
										type: 'error',
										group: 'notification',
										title: 'Registration problem',
										text: 'Selected company name is already taken.',
										duration: 5000,
									});
								}

								if (errorCode[err]['errorMessage'] == 'E-mail already registered') {
									this.vErrors.add({
										field: 'email-user',
										msg: 'E-mail already registered'
									})
								}
							}
						})
                		window.grecaptcha.reset();
						this.captchaToken = '';
					}
			}).catch(err => {
				console.log(err)
			});
		},
		showTermsModal(ev) {
			ev.preventDefault();
			this.$refs['accept-terms'].show();
			this.termsConditionsAccepted = false;
			this.termsRead = false;
		},
		hideTermsModal() {
			this.termsConditionsAccepted = false;
			this.$refs['accept-terms'].hide();
		},
		acceptTerms() {
			this.termsConditionsAccepted = true;
			this.$refs['accept-terms'].hide();
		},
		checkScroll(ev) {
			let maxScroll = ev.target.scrollHeight - ev.target.clientHeight;
			let currentScrollPosition = ev.target.scrollTop;
			if (currentScrollPosition >= (maxScroll - 5)) {
				this.termsRead = true;
			}
		},
		getTermsContent() {
			Axios.get(globalStore.data.restApiUrl + '/terms-and-conditions/most-recent')
			.then(response => {
				this.termsContent = response.data.content;
			})
			.catch(error => {
				console.log(error)
			})
		}
	},
	mounted: function() {
		if (this.$route.params.accountType == undefined) {
			this.$router.push('/register/select-type')
		} else {
			this.classTypeAccount = this.$route.params.accountType
		}

		this.getTimezones()
		var timestamp = new Date().getTime();

		this.getTermsContent();

		fetch('https://api.ipify.org?format=json')
		.then(response => response.json())
		.then(response => {
			this.clientIp = response.ip;
		});

		if (this.$cookies.get("token")) {
			this.$router.push("/dashboard");
		}
	},
};
</script>

<style lang="scss">

input[name="address2-user"] {
	margin-top: 20px;
}

.contentpage {
	background-color: #F8F8F8;
	padding: 43px 0 90px;
	text-align: center;

	.container-register {
		max-width: 520px;
		margin-left: auto;
		margin-right: auto;
		text-align: left;

		h3 {
			font: 700 17px/23px "Roboto", "Arial", sans-serif;
			color: #000000;
		}

		h4 {
			display: block;
			margin-bottom: 30px;
			font: 400 15px/20px "Roboto", "Arial", sans-serif;
		}

		button {
			display: block;
			width: 100%;
			height: 56px;
			margin-bottom: 10px;

			background-color: #0088FF;
			font: 400 15px/43px "Roboto", "Arial", sans-serif;
			color: #fff;
			opacity: 0.8;
			transition: all .1s ease-in;

			&:hover {
				opacity: 1;
				transition: all .1s ease-in;
			}

			&.btn-maker {
				background-color: #00F29F;
			}
		}
	}

	a {
		font-size: 14px;
	}
}

.step2 {
	.formRegister {
		padding: 10px 20px;
		border: 1px solid #C9CFD4;
		border-radius: 5px;
		background-color: #FFFFFF;

		.auto-fill-address {
			position: relative;
			margin: 20px 0;
			.auto-fill-input {}
			.auto-fill-hints-list {
				position: absolute;
				top: 35px;
				left: 0;
				right: 0;
				border: 1px solid #c9cfd4;
				border-top: 0;
				border-bottom-right-radius: 5px;
				border-bottom-left-radius: 5px;
				background-color: #fff;
				z-index: 10;
				.auto-fill-hint {
					padding: 4px 10px;
					border-bottom: 1px solid #c9cfd4;
					cursor: pointer;
					&:hover {
						background-color: #f0f3f5;
					}
					&:last-child {
						border-bottom: 0;
					}
				}
			}
			.auto-fill-error {
				position: absolute;
				top: 35px;
				left: 0;
				right: 0;
				color: #FC4D4D;
				font-size: 12px;
			}
		}

		.address-card {
			margin: 20px 0 0;
		}

		label {
			display: block;
			margin-top: 18px;
			font: 400 12px/16px "Roboto", "Arial", sans-serif;
			color: #2F353A;
		}

		select {
			max-width: none;
		}

		.big-input {
			width: 76%;
			display: inline-block;
		}

		.small-input {
			display: inline-block;
			margin-right: 4%;
			width: 20%;
		}

		.button-wrap {
			text-align: right;
			margin-top: 20px;
			button {
				width: auto;
				height: 35px;
				display: inline-block;
				padding: 0 40px;
				margin-left: 10px;
				border: 0;
				border-radius: 5px;
				line-height: 35px;
				outline: none !important;

				&.btn-back {
					background: transparent;
					color: #000;
				}
			}
		}
	}
}

.company-field {
	display: none;
}

.Business,
.Maker {
	.company-field {
		display: block;
	}
}

footer {
	padding: 25px 0 100px;
	text-align: center;
}
.vue-tel-input {
	background-color: #F0F3F5;
	.vti__input {
		background-color: transparent !important;
	}
}

.vti__input {
	background-color: transparent;
}

.container-register {
	.error-field {
		input,
		select,
		.vue-tel-input {
			border-color: #FC4D4D;
			box-shadow: inset 0 0 0 1px #FC4D4D;
			transition: all .4s ease-in-out;
		}
		.validate-warning {
			color: #FC4D4D;
			font-size: 12px;
			transition: all .4s ease-in-out;
		}
	}
}

	.terms-and-conditions {
		margin-top: 20px;
		.terms-and-conditions-box {
			display: flex;

			label {
				margin: 0 0 0 10px;
				cursor: pointer;
				span {
					.colored {
						color: #0088F1;
					}
				}
			}
			input {
				cursor: pointer;
			}
		}
	}

	#accept-terms___BV_modal_content_ {
		background-color: #ffffff;
		color: #000000;

		.terms-and-conditions-topbar {
			display: flex;
			justify-content: space-between;
			margin-bottom: 8px;

			h3 {
				font-size: 15px;
			}

			i {
				cursor: pointer;
				&:before {
					color: #000000;
				}
			}
		}

		.terms-and-conditions-text {
			width: 100%;
			max-height: 80vh;
			overflow: scroll;
			padding-right: 12px;
		}

			.terms-and-conditions-text iframe {
				width: 100%;
				height: 70vh;
			}

		.accept-bar {
			display: flex;
			p {
				color: #0088FF;
			}
			&.buttons-visible {
				justify-content: flex-end;
				p {
					display: none;
				}
				button {
					display: initial;
				}
				.accept {
					margin-left: 20px;
				}
			}

			&.text-visible {
				justify-content: center;
				button {
					display: none;
				}
				p {
					display: initial;
				}
			}
		}
	}
	.header-animation {
		&.step2 {
			.top {
				background-color: #021927;
			}
		}
	}

	.template-login-register {
		.step2 + .contentpage {
			padding-top: 76px;
		}
	}


	.header-animation {
		&.step2 {
			.top {
				background-color: #021927;
			}
		}
	}

	.template-login-register {
		.step2 + .contentpage {
			padding-top: 76px;
		}
	}

	.recaptcha {
		margin-top: 20px;
	}
</style>
